import { Route, Routes } from "react-router-dom";

import { UploadVisualAreaContent } from "@/components/flow/build/Steps/Upload/VisualAreaContent";
import { GuardedRoute } from "@/components/routing/GuardedRoute";
import { useGuardUpload } from "@/hooks/guards/useGuardUpload";

export const SetupRoutes = () => {
    return (
        <Routes>
            <Route
                index
                element={
                    <GuardedRoute useGuardStep={useGuardUpload}>
                        <UploadVisualAreaContent />
                    </GuardedRoute>
                }
            />
        </Routes>
    );
};
